
import { defineComponent } from 'vue'

// link information
interface LinkInfo {
  title: string,
  url: string
}

export default defineComponent({
  name: 'LinkJa',
  data () {
    return {
      links: [
        {
          title: '東京大学大学院総合文化研究科 加藤雄介研究室',
          url: 'http://webpark1378.sakura.ne.jp'
        },
        {
          title: '理化学研究所 古崎物性理論研究室',
          url: 'http://www2.riken.jp/lab-www/cond-mat-theory'
        },
        {
          title: '京都大学大学院理学研究科 物理学・宇宙物理学専攻 凝縮系理論グループ',
          url: 'http://cond.scphys.kyoto-u.ac.jp'
        }
      ] as LinkInfo[]
    }
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'link'
    }
  }
})
